import { render, staticRenderFns } from "./UserCouponsList.vue?vue&type=template&id=1e8f0caa&scoped=true&"
import script from "./UserCouponsList.vue?vue&type=script&lang=js&"
export * from "./UserCouponsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f0caa",
  null
  
)

export default component.exports